import React, { useEffect } from 'react';

const Toast = ({ message, onClose, duration = 5000 }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [message, duration, onClose]);

  if (!message) return null;

  return (
    <div className="fixed top-6 right-6 z-50 bg-green-600 text-white px-6 py-3 rounded-lg shadow-lg flex items-center toast-body">
      <span className="text-sm">{message}</span>
      <button onClick={onClose} className="ml-4 font-bold">×</button>
    </div>
  );
};

export default Toast;